import React from 'react'
import styled from 'styled-components'
import { Flex, Text } from 'vvs-uikit'
import QuestionHelper from 'components/QuestionHelper'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'

const Wrapper = styled.div`
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.background};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.boostBackground};
`

const MultiplierRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`

const SummaryBox = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.boostDivider};
  margin-top: 12px;
  padding-top: 17px;
`

type MultiplierContent = {
  xVVSBoostFactor: number
  nftBoostFactor: number
  totalFactor?: number
}

const MultiplierContent: React.FC<MultiplierContent> = ({ xVVSBoostFactor, nftBoostFactor, totalFactor }) => {
  const { t } = useTranslation()
  const { theme } = useTheme()

  return (
    <Wrapper>
      <MultiplierRow>
        <Text fontSize="13px" fontWeight="350" lineHeight="18px" color="textSubtle">
          {t('xVVS Boost Factor')}
        </Text>
        <Text fontSize="13px" fontWeight="350" lineHeight="18px">
          {xVVSBoostFactor}x
        </Text>
      </MultiplierRow>
      <MultiplierRow>
        <Text fontSize="13px" fontWeight="350" lineHeight="18px" color="textSubtle">
          {t('NFT Boost Factor')}
        </Text>
        <Text fontSize="13px" fontWeight="350" lineHeight="18px">
          {nftBoostFactor}x
        </Text>
      </MultiplierRow>
      <SummaryBox>
        <MultiplierRow>
          <Flex alignItems="center">
            <Text fontSize="20px" lineHeight="32px" marginRight="5px" color="textSubtle" textTransform="uppercase">
              {t('total boost factor')}
            </Text>
            <QuestionHelper
              text={t(
                'Boosted rewards is the sum of base APR plus extra rewards boosted by holding xVVS. The “x” is the ratio of Boosted rewards over the base reward',
              )}
              ml="4px"
              mt="3px"
              placement="auto-start"
              iconColor={theme.colors.text}
            />
          </Flex>
          <Text fontSize="20px" lineHeight="32px">
            {totalFactor
              ? `${totalFactor}x`
              : nftBoostFactor && xVVSBoostFactor
              ? `${(nftBoostFactor * xVVSBoostFactor).toFixed(2)}x`
              : `${(nftBoostFactor + xVVSBoostFactor).toFixed(2)}x`}
          </Text>
        </MultiplierRow>
      </SummaryBox>
    </Wrapper>
  )
}

export default MultiplierContent
